module.exports = __webpack_public_path__ + "static/media/f_hairstyle_frizzy_short_back_vector.d1cc5159.svg";